module.exports = __webpack_public_path__ + "img/bg-account.d1e5eebf.png";